import { put, call,　takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';



function* mailGroupListGet(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('filter', payload.filter);
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/mailGroupListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MAIL_GROUP_LIST_SET",
        payload: {
          list: res.data.list,
          filter: action.payload.filter,
          page: action.payload.page,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* mailGroupItemDel(action) {
  yield put(loadingSet(true));

  const res = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/mailGroupEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MAIL_GROUP_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });

    }
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('MAIL_GROUP_LIST_GET', mailGroupListGet),
  takeLatest('MAIL_GROUP_ITEM_DEL', mailGroupItemDel),
];

export default saga;
